module.exports = __webpack_public_path__ + "img/Zhongguancun.9f9c0d09.png";